import { render, staticRenderFns } from "./nature.vue?vue&type=template&id=2cb23abc&scoped=true&"
import script from "./nature.vue?vue&type=script&lang=js&"
export * from "./nature.vue?vue&type=script&lang=js&"
import style0 from "./nature.vue?vue&type=style&index=0&id=2cb23abc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb23abc",
  null
  
)

export default component.exports